import React, { useState } from 'react';
import { Button, Message, Input, Modal } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import {
  PRIVACY_DISPLAY_CLASSES,
  PRIVACY_FIELD_CLASS,
} from 'utils/privacyClasses';

import styles from './PhoneNumberInputModal.module.css';

type Props = {
  phoneNumber?: string | null;
  showModal: boolean;
  setPhoneNumber: (phoneNumber: string) => void;
  closeModal: () => void;
};
export const PhoneNumberInputModal: React.FunctionComponent<Props> = ({
  phoneNumber,
  showModal,
  setPhoneNumber,
  closeModal,
}) => {
  const [updatedPhoneNumber, setUpdatedPhoneInput] = useState('');
  const [hasError, setHasError] = useState(false);
  const phoneNumberRegex = /^(?:(?:(?:00\s?|\+)44\s?|0)(?:[123678]\d{8,9}))$/;

  const onConfirmButtonClick = () => {
    const validNumber = updatedPhoneNumber.match(phoneNumberRegex);
    if (validNumber) {
      setPhoneNumber(updatedPhoneNumber);
      closeModal();
      return;
    }
    setHasError(true);
  };

  return (
    <Modal closeIcon isOpen={showModal} onClose={closeModal} size="medium">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onConfirmButtonClick();
        }}
      >
        <p className={clsx(styles.current, PRIVACY_DISPLAY_CLASSES)}>
          <Trans>Current number:</Trans> {phoneNumber}
        </p>
        <Input
          data-testid="phone-number-input"
          className={clsx(styles.input, PRIVACY_FIELD_CLASS)}
          defaultValue={updatedPhoneNumber}
          onChange={(e) => {
            setHasError(false);
            setUpdatedPhoneInput(e.target.value);
          }}
          placeholder={t`Enter a new number`}
        />
        <div className={styles.buttonsContainer}>
          <Button
            onClick={() => {
              closeModal();
            }}
            variant="tertiary"
            type="button"
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button
            className={styles.confirmButton}
            disabled={hasError}
            variant="primary"
            type="submit"
          >
            <Trans>Save this new number</Trans>
          </Button>
        </div>
        {hasError && (
          <Message
            className={styles.errorMessage}
            message={t`Please enter a correct phone number`}
            type="error"
          />
        )}
      </form>
    </Modal>
  );
};
